// extracted by mini-css-extract-plugin
module.exports = {"title":"UPR1oNIiNx","button":"_1pr7ewM2pz"};
    if(module.hot) {
      // 1614934709153
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  